'use client';

import { Button, ButtonProps } from '@/components/shared/Button';

type ScrollToTopButtonProps = Omit<ButtonProps, 'onClick' | 'children'>;

export const ScrollToTopButton = (props: ScrollToTopButtonProps) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Button {...props} onClick={scrollToTop}>
      Voltar para o topo
    </Button>
  );
};
